/**
 * Employment type of a creative. Mirrors backend-platform `CreativeType`
 * (`dto/async/creativeinformation/CreativeType.kt`), exposed on `SuggestedCreativeDTO` since
 * ISSUE-3177 (backend PR #275).
 */
export enum CreativeType {
  /** Creative employed by BKBN */
  IN_HOUSE = 'IN_HOUSE',
  /** External / freelance creative */
  FREELANCER = 'FREELANCER',
}
